import { Track } from './track';

export class ActiveTrack {
	track : Track; 
	IsPlaying : boolean;
}